import { useEffect, useRef } from 'react';
import ScrollReveal from 'scrollreveal';

const useScrollReveal = (options = {}) => {
  const elementRef = useRef(null);

  useEffect(() => {
    if (elementRef.current) {
      ScrollReveal().reveal(elementRef.current, {
        origin: 'bottom',
        distance: '60px',
        duration: 1000,
        delay: 200,
        easing: 'ease',
        reset: false,
        ...options
      });
    }
  }, [options]);

  return elementRef;
};

export default useScrollReveal;